import { action } from 'easy-peasy';

const withResetState = (model, initialState) => ({
  ...model,
  reset: action(() => ({ ...initialState })),
});

export default withResetState;
